















export default {
    name: 'chips',
    props: {
        iconStart: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            required: true,
        },
        iconEndClass: {
            type: String,
            default: null,
        },
    },
};
